

























































































































import { Vue, Component } from 'vue-property-decorator';
import CompRadioButton from '@/components/common/CompRadioButton.vue';
import CompCheckBox from '@/components/common/CompCheckBoxButton.vue';
import { CheckBoxOptions } from '@/types/common';
import {
  AccountData,
  PopupAccountData,
  PlatformDisplayYn,
  PlatformDisplayBoolean,
  PlatformDisplayYnToBoolean,
  PopupBannerDisplayOptionData,
} from '@/types/banner';
import {
  decodeCheckYorN,
  decodeRadioAllOrNoneOrAny,
  EncodeNoneAllAnyOption,
  NoneAllAnyOption,
} from '@/utils/dataReplaceUtils';
import { isEqual } from 'underscore';
import bannerDisplayOptions from '@/components/banner/popup/PopupBannerDisplayOption';

declare global {
  interface Window {
    parentData?: PopupBannerDisplayOptionData;
  }
}

@Component({
  components: {
    CompRadioButton,
    CompCheckBox,
  },
})
export default class PopupBannerDisplayOption extends Vue {
  private readonly sectionNo: string = this.$route.query.sectionNo.toString();
  private popupAccountData: PopupAccountData | null = null;
  private parentPlatformDisplay: PlatformDisplayYnToBoolean | null = null;
  private parentMemberGradeDisplayInfo: NoneAllAnyOption | null = null;
  private parentMemberGroupDisplayInfo: NoneAllAnyOption | null = null;

  private memberGradeDetailDisplayOptions: CheckBoxOptions | null = null;
  private memberGroupDetailDisplayOptions: CheckBoxOptions | null = null;
  private readonly bannerDisplayOptions = bannerDisplayOptions();

  created() {
    document.body.classList.add('popup');

    this.fetchParentData();
  }

  private fetchParentData() {
    const parentData = window?.parentData;

    // 부모 데이터가 없을 시 반려
    if (window?.parentData === undefined) {
      alert(this.$t('ALERT_WRONG_ACCESS'));
      this.onCloseWindow();
      return;
    }

    // popupAccountData 생성
    const { accountData, commonData } = parentData;
    this.popupAccountData = {
      type: 'popup',
      ...accountData,
    };

    // 플랫폼별 노출 설정
    this.setPlatformDisplay(accountData.platformDisplay, commonData.platformDisplay);

    // 회원 등급/그룹 별 노출설정
    this.setPopupMemberOptions(parentData);

    // 회원 등급/그룹 별 선택상태 반영
    const { memberGradeDisplayInfo, memberGroupDisplayInfo } = accountData;
    const { memberGradeDisplay, memberGroupDisplay } = commonData;

    this.parentMemberGradeDisplayInfo = decodeRadioAllOrNoneOrAny(memberGradeDisplay);
    this.parentMemberGroupDisplayInfo = decodeRadioAllOrNoneOrAny(memberGroupDisplay);

    this.setPopupMemberOptionsCheck(
      'grade',
      memberGradeDisplayInfo,
      memberGradeDisplay,
      this.memberGradeDetailDisplayOptions,
    );
    this.setPopupMemberOptionsCheck(
      'group',
      memberGroupDisplayInfo,
      memberGroupDisplay,
      this.memberGroupDetailDisplayOptions,
    );
  }

  private setPlatformDisplay(
    { displayPcYn, displayMobileYn, displayMobileWebYn }: PlatformDisplayYn,
    { displayPc, displayMobile, displayMobileWeb }: PlatformDisplayBoolean,
  ): void {
    this.popupAccountData.platformDisplay = {
      displayPcYn: displayPcYn === 'Y',
      displayMobileYn: displayMobileYn === 'Y',
      displayMobileWebYn: displayMobileWebYn === 'Y',
    };

    this.parentPlatformDisplay = {
      displayPcYn: displayPc,
      displayMobileYn: displayMobile,
      displayMobileWebYn: displayMobileWeb,
    };

    this.setPlatformDisplaySameOption(this.popupAccountData.platformDisplay, this.parentPlatformDisplay);
  }

  private platformDisplayOption: 'NONE' | 'ANY' = 'NONE';
  private setPlatformDisplaySameOption(child: PlatformDisplayYnToBoolean, parent: PlatformDisplayYnToBoolean): void {
    const isEqualCommon = isEqual(child, parent);

    this.platformDisplayOption = isEqualCommon ? 'NONE' : 'ANY';
  }

  private setPopupMemberOptions({
    memberGradeDetailDisplayOptions,
    memberGroupDetailDisplayOptions,
  }: PopupBannerDisplayOptionData): void {
    this.memberGradeDetailDisplayOptions = memberGradeDetailDisplayOptions;
    this.memberGroupDetailDisplayOptions = memberGroupDetailDisplayOptions;
  }

  private setPopupMemberOptionsCheck(
    type: 'grade' | 'group',
    child: EncodeNoneAllAnyOption | NoneAllAnyOption,
    parent: EncodeNoneAllAnyOption,
    childOption: CheckBoxOptions,
  ): void {
    const keyHead = `member_${type}`;

    // console.log('parent check : %s', parent.check);
    // console.log('child check : %s', child.check);
    switch (parent.check) {
      case 'NONE':
        // console.log(child.check);
        switch (child.check) {
          case 'NONE':
            // console.log('case 1');
            child.info = 'ALL';
            break;
          case 'ALL':
            // console.log('case 2');
            child.check = 'ANY';
            child.info = 'ALL';
            break;
          case 'ANY':
            // console.log('case 3');
            if (!Array.isArray(child.info)) break;
            child.info = child.info
              .map(v => {
                if (isNaN(v)) return;
                return `${keyHead}-${v}`;
              })
              .join(',');
            break;
        }
        break;
      case 'ANY':
        switch (parent.info) {
          case 'ALL':
            switch (child.check) {
              case 'NONE':
                // console.log('case 4');
                child.info = 'ALL';
                break;
              case 'ALL':
                // console.log('case 5');
                child.check = 'NONE'; // 화면 정보만 이렇게 보여줌
                child.info = parent.info;
                break;
              case 'ANY':
                // console.log('case 6');
                if (child.info === 'ALL') {
                  child.check = 'NONE'; // 화면 정보만 이렇게 보여줌
                  child.info = parent.info;
                  return;
                }

                if (!Array.isArray(child.info)) break;
                child.info = child.info
                  .map(v => {
                    if (isNaN(v)) return;
                    return `${keyHead}-${v}`;
                  })
                  .join(',');
                break;
            }
            break;
          // 'ANY'
          default:
            childOption.hasAll = false;
            childOption.data.splice(0, 1);
            switch (child.check) {
              case 'NONE':
                // console.log('case 7');
                child.check = 'ANY';
                child.info = parent.info;
                break;
              case 'ALL':
                // console.log('case 8');
                child.check = 'ANY';
                child.info = parent.info;
                break;
              case 'ANY':
                // console.log('case 9');
                if (!Array.isArray(child.info)) break;
                child.info = child.info
                  .map(v => {
                    if (isNaN(v)) return;
                    return `${keyHead}-${v}`;
                  })
                  .join(',');

                if (child.info === parent.info) child.check = 'NONE'; // 화면 정보만 이렇게 보여줌
                break;
            }
        }
        break;
    }
  }

  private emitPopupMemberOptionsCheck(child: EncodeNoneAllAnyOption, parent: NoneAllAnyOption): NoneAllAnyOption {
    const result: NoneAllAnyOption = {
      check: child.check,
      info: [],
    };

    switch (parent.check) {
      case 'NONE':
        switch (child.check) {
          case 'NONE':
            // console.log('decode case 1');
            // 초기 선언 그대로 아래 처럼 반영 됨
            // result.case = 'NONE'
            // result.info = []
            break;
          case 'ANY':
            // console.log('decode case 2');
            if (child.info.length === 0) break;
            if (child.info === 'ALL') {
              result.check = 'ALL';
              result.info = [];
              break;
            }

            result.info = child.info.includes(',')
              ? child.info.split(',').map(v => Number(v.split('-')[1]))
              : [Number(child.info.split('-')[1])];
            break;
        }
        break;
      case 'ALL':
        switch (child.check) {
          case 'NONE':
            // console.log('decode case 3');
            // 초기 선언 그대로 아래 처럼 반영 됨
            // result.case = 'ALL'
            // result.info = []
            break;
          case 'ANY':
            // console.log('decode case 4');
            if (child.info.length === 0) break;
            if (child.info === 'ALL') {
              result.check = 'ALL';
              result.info = [];
              break;
            }

            result.info = child.info.includes(',')
              ? child.info.split(',').map(v => Number(v.split('-')[1]))
              : [Number(child.info.split('-')[1])];
            break;
        }
        break;
      case 'ANY':
        switch (child.check) {
          case 'NONE':
            // console.log('decode case 5');
            // 초기 선언 그대로 아래 처럼 반영 됨
            // result.case = 'ANY'
            // result.info = []
            break;
          case 'ANY':
            // console.log('decode case 6');
            if (child.info.length === 0) break;
            if (child.info === 'ALL') {
              result.info = parent.info;
              break;
            }

            result.info = child.info.includes(',')
              ? child.info.split(',').map(v => Number(v.split('-')[1]))
              : [Number(child.info.split('-')[1])];
            break;
          default:
        }
        break;
    }

    return result;
  }

  private getAccountData(popupAccountData: PopupAccountData): AccountData {
    const data: PopupAccountData | AccountData = JSON.parse(JSON.stringify(popupAccountData));
    const { platformDisplay, memberGradeDisplayInfo, memberGroupDisplayInfo } = popupAccountData;

    const { displayPcYn, displayMobileYn, displayMobileWebYn } = platformDisplay;
    data.platformDisplay = {
      displayPcYn: displayPcYn ? 'Y' : 'N',
      displayMobileYn: displayMobileYn ? 'Y' : 'N',
      displayMobileWebYn: displayMobileWebYn ? 'Y' : 'N',
    };

    data.memberGradeDisplayInfo = this.emitPopupMemberOptionsCheck(
      memberGradeDisplayInfo as EncodeNoneAllAnyOption,
      this.parentMemberGradeDisplayInfo,
    );
    data.memberGroupDisplayInfo = this.emitPopupMemberOptionsCheck(
      memberGroupDisplayInfo as EncodeNoneAllAnyOption,
      this.parentMemberGroupDisplayInfo,
    );

    return data as AccountData;
  }

  private onClickSave() {
    this.emitData();
    this.onCloseWindow();
  }

  private emitData(): void {
    const { displayType, platformDisplay, memberGradeDisplayInfo, memberGroupDisplayInfo } = this.getAccountData(
      this.popupAccountData,
    );

    window.opener.emitChildData(
      {
        displayType: displayType,
        platformDisplay:
          this.platformDisplayOption === 'NONE' ? decodeCheckYorN(this.parentPlatformDisplay) : platformDisplay,
        memberGradeDisplayInfo:
          memberGradeDisplayInfo.check === 'NONE' ? this.parentMemberGradeDisplayInfo : memberGradeDisplayInfo,
        memberGroupDisplayInfo:
          memberGroupDisplayInfo.check === 'NONE' ? this.parentMemberGroupDisplayInfo : memberGroupDisplayInfo,
      },
      this.sectionNo,
    );
  }

  private onClickClose() {
    this.onCloseWindow();
  }

  public onCloseWindow() {
    window.close();
  }
}
